import DroppableColumn from './DroppableColumn';

export default DroppableColumn;